export default __webpack_public_path__ + "static/media/Switch.c3aeb714.jpg";